import { Component, OnInit } from '@angular/core'
import { ClientService } from '../client.service'
import { ToastrService } from 'ngx-toastr'
import { CommonModule } from '@angular/common'
import { Router } from '@angular/router'
import { ClientModel } from '../client.model'
import { MatDialog } from '@angular/material/dialog'
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component'
import { MasterCommonServices } from '../../quotation/master.common.service'
import { AuthStateService } from '../../../auth-state.service'
import { FormsModule } from '@angular/forms'

@Component({
  selector: 'app-view-clients',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './view-clients.component.html',
  styleUrl: './view-clients.component.css',
})
export class ViewClientsComponent implements OnInit {
  isLoading: boolean = false
  permissions: string[] = []

  filteredClientsList: ClientModel[] = []

  filter = {
    companyName: '',
    address: '',
    region: '',
    website: '',
  }

  constructor(
    private authStateService: AuthStateService,
    private clientService: ClientService,
    private toastr: ToastrService,
    private router: Router,
    private dialog: MatDialog,
    public masterCommonService: MasterCommonServices,
  ) {
    this.authStateService.permissions.subscribe((permList) => {
      this.permissions = permList
    })
  }

  ngOnInit(): void {
    if (this.masterCommonService.clientsList.length === 0) {
      this.masterCommonService.getAllClients()
    }

    this.filteredClientsList = [...this.masterCommonService.clientsList]

    setTimeout(() => {
      this.filteredClientsList = [...this.masterCommonService.clientsList]
    }, 500)
  }

  hasPermission(action: string): boolean {
    return this.permissions.includes(action)
  }

  applyFilters(): void {
    this.filteredClientsList = this.masterCommonService.clientsList.filter(
      (client) => {
        return (
          (!this.filter.companyName ||
            client.companyName
              ?.toLowerCase()
              .includes(this.filter.companyName.toLowerCase())) &&

          (!this.filter.address ||
            client.address
              ?.toLowerCase()
              .includes(this.filter.address.toLowerCase())) &&

          (!this.filter.region ||
            client.region
              ?.toLowerCase()
              .includes(this.filter.region.toLowerCase())) &&

          (!this.filter.website ||
            client.website
              ?.toLowerCase()
              .includes(this.filter.website.toLowerCase()))
        )
      },
    )
  }

  resetFilters(): void {
    this.filter = {
      companyName: '',
      address: '',
      region: '',
      website: '',
    }

    this.filteredClientsList = [...this.masterCommonService.clientsList]
  }

  viewClient(client: ClientModel) {
    this.router.navigate(['/addClient'], {
      queryParams: { mode: 'view', ...client },
    })
  }

  updateClient(client: ClientModel) {
    this.router.navigate(['/addClient'], {
      state: {
        mode: 'update',
        client: client,
      },
    })
  }

  deleteClient(client: ClientModel): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { message: 'Are you sure you want to delete this client?' },
    })

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.clientService.deleteClient(client).subscribe({
          next: () => {
            this.masterCommonService.clientsList =
              this.masterCommonService.clientsList.filter(
                (p) => p.id !== client.id,
              )

            this.applyFilters()

            this.toastr.success(
              'Client Deleted Successfully!',
              'Success',
            )
          },
          error: (error: any) => {
            this.toastr.error(error.statusText, 'Error', {
              timeOut: 15000,
              closeButton: true,
              progressBar: true,
            })
          },
        })
      }
    })
  }
}